// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__JC7rQ","rotation":"Loader_rotation__jXYdK"};